import React, { useState } from "react";
import styles from "./style.scss";
import { ChatForm } from "../Components/ChatForm";
import { Recommendation } from "../Components/Recommendation";

const SAMPLE_RECOMMENDATIONS = [
  "〇〇社の成長戦略（投資領域・重点施策）を3点で説明してください。",
  "〇〇社の経営に影響する最近のニュースを重要度順にまとめてください。",
  "〇〇業界の外部環境（PEST）を簡潔にまとめてください。"
];

interface Props {
  handleSubmit: (text: string) => void;
  onCancel: () => void;
}

// 新規チャットコンポーネント
export const NewChat: React.FC<Props> = ({ handleSubmit, onCancel }) => {
  const [text, setText] = useState("");

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>調べたいテーマを入力してください</div>
      <div className={styles.form}>
        <div className={styles.chat}>
          <ChatForm
            type="newChat"
            text={text}
            onChangeText={setText}
            onSubmit={text => {
              handleSubmit(text);
            }}
            onCancel={onCancel}
            isLoading={false}
          />
          <div className={styles.disclaimer}>
            生成AIの回答は必ずしも正しいとは限りません。正確な情報はソースを確認してください。
          </div>
        </div>
        <Recommendation
          recommendation={SAMPLE_RECOMMENDATIONS}
          onClickTips={text => {
            setText(text);
          }}
        />
      </div>
    </div>
  );
};
